import { render, staticRenderFns } from "./TableMatrixV2.vue?vue&type=template&id=4ab687e2&scoped=true"
import script from "./TableMatrixV2.vue?vue&type=script&lang=js"
export * from "./TableMatrixV2.vue?vue&type=script&lang=js"
import style0 from "./TableMatrixV2.vue?vue&type=style&index=0&id=4ab687e2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab687e2",
  null
  
)

export default component.exports